import React from "react";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import { useDispatch, useSelector } from "react-redux";

const TableOrStackedBarChart = () => {
  const dispatch = useDispatch();
  const table_view = useSelector((state) => state.onDemandRevenue.selectedFilters.table_view);
  const {
    options,
    data_table: { rows, cols }
  } = useSelector((state) => state.onDemandRevenue.chartData);

  const { currencySymbol } = useSelector((state) => state.commonReducer.commonProps);

  const handleUpdateChart = (data) => {
    dispatch(actionCreators.updateTableView(data));
  };

  return (
    <GoogleChart
      chartName="sales_revenue_service_sales_chart"
      width="1350px"
      height={400}
      isTableView={table_view}
      rows={rows}
      columns={cols}
      options={options}
      enableEventListeners
      switchView={handleUpdateChart}
      currencySymbol={currencySymbol}
    />
  );
};

export default TableOrStackedBarChart;
